<template>
  <nav-submenu label="Awards">
    <b-dropdown-item to="/awards">Awardees</b-dropdown-item>
    <template v-if="isAuthenticated">
      <b-dropdown-item to="/awards/nominations">
        My nominations
      </b-dropdown-item>
      <b-dropdown-item to="/awards/references?section=waiting_for_letter" v-if="references.length">
        My reference letters
      </b-dropdown-item>
      <b-dropdown-item to="/awards/evaluations" v-if="hasReviews">
        My evaluations
      </b-dropdown-item>
      <b-dropdown-item to="/awards/decisions" v-if="reportsCount > 0">
        Decisions
      </b-dropdown-item>
    </template>
  </nav-submenu>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import References from '@/services/Api/Awards/References';
import NavSubmenu from '@/views/components/nav/NavSubmenu.vue';

export default {
  name: 'AwardsNavItem',
  components: { NavSubmenu },
  created() {
    if (this.isAuthenticated) {
      if (this.loadingReferences === false) {
        this.fetchReferences();
      }

      if (this.loadingReviews === false) {
        this.fetchReviews();
      }

      if (this.loadingReports === false) {
        this.fetchReports({ count: true }).then((response) => {
          this.reportsCount = response.data.data.count;
        });
      }
    }
  },
  data() {
    return {
      references: [],
      reportsCount: 0,
    };
  },
  methods: {
    fetchReferences() {
      References.all().then((response) => {
        this.references = response.data.data;
      });
    },
    ...mapActions({
      fetchReviews: 'awardsReviews/fetchReviews',
      fetchReports: 'awardsReports/fetchReports',
    }),
  },
  computed: {
    ...mapState({
      loadingReferences: (state) => state.awardsReferences.loading,
      loadingReviews: (state) => state.awardsReviews.loading,
      loadingReports: (state) => state.awardsReports.loading,
    }),
    ...mapGetters({
      hasReviews: 'awardsReviews/hasReviews',
      isAuthenticated: 'auth/isAuthenticated',
      user: 'auth/user',
    }),
  },
};
</script>
